export const STORYBLOK_BMI_CALCULATOR_CATEGORY = {
  NO_VALUE: 'no_value',
  NORMAL_WEIGHT: 'normal_weight',
  OBESITY: 'obesity',
  OVERWEIGHT: 'overweight',
  UNDERWEIGHT: 'underweight',
} as const

export type STORYBLOK_BMI_CALCULATOR_CATEGORY =
  (typeof STORYBLOK_BMI_CALCULATOR_CATEGORY)[keyof typeof STORYBLOK_BMI_CALCULATOR_CATEGORY]
